import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.use(require('vue-script2'))
// import * as firebase from 'firebase/app';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import './components/firebaseInit';
import Vuex from 'vuex';

Vue.use(Vuex);

// import { store } from './store/store';

Vue.config.productionTip = false

// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')

// let app;
// firebase.auth().onAuthStateChanged(function(user) {
//     if (!app) {
//         console.log(`app is not true`);
//         /* eslint-disable no-new */
//         app = new Vue({
//             el: '#app',
//             store: store,
//             router,
//             template: '<App/>',
//             components: { App }
//         });
//         if (firebase.auth().currentUser) {
//             app.$store.commit( 'user', user )
//         }
//     } else {
//         console.log(`app is true `);
//         app.$store.commit( 'user', user )
//     }   
// });

let app
firebase.auth().onAuthStateChanged(
    p => {
        console.log(`firebase.auth().onAuthStateChanged`);
        if (firebase.auth().currentUser) {
            console.log(`You are logged in as ${firebase.auth().currentUser.email}`);
        }
        if ( app ) {
            console.log(`app is true `);
            app.$store.commit( 'user', p )
        } else {
            console.log(`app is not true`);
            app = new Vue({
                el: '#app',
                router,
                store: new Vuex.Store({
                    state: {
                        user: p
                    },
                    getters: {
                        user: state => state.user
                    },
                    mutations: {
                        user: ( state, payload ) => state.user = payload 
                    }
                }),               
                template: '<App/>',
                components: { App }
            });           
        }
    }
)

